import React from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { setDataVersion } from '../redux/slices/appSlice';
import { path_to_site } from './axios_settings';
import { handleNetworkError } from '../utils/networkErrorHandler';

const GetDataVersion = () => {
  const dispatch = useDispatch();
  const requests_cnt = useSelector((state) => state.tic.requests_cnt);

  React.useEffect(() => {
    // console.log('GetDataVersion useEffect triggered, requests_cnt:', requests_cnt);
    const formData = new FormData();
    formData.append('request', 'get_data_version');

    axios
      .post(path_to_site, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(({ data }) => {
        // console.log('GetDataVersion response:', data);
        // Записываем ответ в Redux dataVersion
        if (data) {
          try {
            const version = parseInt(data);
            if (!isNaN(version)) {
              // console.log('Setting dataVersion to:', version);
              dispatch(setDataVersion(version));
            }
          } catch (error) {
            // console.error('Error parsing version:', error);
          }
        }
      })
      .catch((error) => {
        // Обрабатываем сетевые ошибки (отсутствие интернета)
        if (handleNetworkError(error)) {
          return; // Игнорируем сетевые ошибки
        }

        // Для других ошибок можно добавить логирование, но не показывать пользователю
        // console.error('Error in GetDataVersion:', error);
      });
  }, [requests_cnt, dispatch]);

  return <div></div>;
};

export default GetDataVersion;
